import AppTitle from '@theme/components/atom/AppTitle'
import Breadcrumbs from '@theme/components/molecule/Breadcrumbs'
import CategoryBox from '@theme/components/category/CategoryBox'
import LayoutBase from '@theme/components/shop/LayoutBase'
import MenuItemPageMixin from '@/mixins/MenuItemPageMixin.vue'
import SeoMixin from '@/mixins/SeoMixin.vue'

export default {
  name: 'PageCatalogConfigurable',
  components: { AppTitle, Breadcrumbs, CategoryBox, LayoutBase },
  mixins: [MenuItemPageMixin, SeoMixin],
  props: {
    categoryCms: Object,
    categoryStore: Object,
    products: Array,
  },
  computed: {
    breadcrumbs() {
      return [
        {
          path: this.$route.path,
          title: this.$t('PageCatalogConfigurable.breadcrumbs.title'),
        },
      ]
    },
    parentPage() {
      return this.menuItem?.parent
    },
  },
}
